import { useContext } from 'react';
import { ThemeContext } from '@emotion/react';
import defaultTheme from '../defaultTheme';
import { useMediaQuery } from '@dnhb/node_package';

const useMedia = () => {
  const { mobile, tablet } = useContext(ThemeContext);

  const onMobile = useMediaQuery(mobile || defaultTheme.mobile);
  const onTablet = useMediaQuery(tablet || defaultTheme.tablet);

  return { onMobile, onTablet };
};

export default useMedia;
